import React from 'react'
import './App.css'
import Header from './MGF/Header'
import Home from './MGF/Home'
import ProjectButton from './MGF/ProjectButton'
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom"
import Projects from './MGF/Projects'
import Photos from './MGF/Photos'
import Videos from './MGF/Videos'
import Live from './MGF/Live'
import Community from './MGF/Community'


function App() {
  return (
    <div className='app'>
      <Router>
        <Header />

         <Link to='/projects'>
             <ProjectButton />
         </Link>
        
        <Switch>
          <Route path='/projects' component={Projects} />
          <Route path='/photos' component={Photos} />
          <Route path='/videos' component={Videos} />
          <Route path='/live' component={Live} />
          <Route path='/community' component={Community} />
          <Route path='/' exact component={Home} />
        </Switch>
      </Router>
    </div>
  )
}

export default App
